import axios from "../axios-auth";

export const branchService = {
    getBranchList,
    saveBranch,
    getBranchDetail,
    getBranchByStatus,
};

function getBranchList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    return axios.get("/auth/branches", { params });
}

function saveBranch(branch) {
    if (!branch.id) {
        // new brand
        return axios.post("/auth/branch", branch);
    } else {
        // edit
        return axios.put("/auth/branch", branch);
    }
}

function getBranchDetail(id) {
    return axios.get("/auth/branch/" + id);
}

function getBranchByStatus(status) {
    return axios.get("/auth/branch-by-status/" + status);
}
